import { NavLink } from "react-router-dom";

export function BottomNav() {
  return (
    <nav className="bottom-nav" aria-label="メインナビゲーション">
      <NavLink to="/" end>{({ isActive }) => <span className={isActive ? "active" : ""}>記録</span>}</NavLink>
      <NavLink to="/charts">{({ isActive }) => <span className={isActive ? "active" : ""}>グラフ</span>}</NavLink>
      <NavLink to="/history">{({ isActive }) => <span className={isActive ? "active" : ""}>履歴</span>}</NavLink>
      <NavLink to="/foods">{({ isActive }) => <span className={isActive ? "active" : ""}>食品</span>}</NavLink>
      <NavLink to="/sets">{({ isActive }) => <span className={isActive ? "active" : ""}>セット</span>}</NavLink>
      <NavLink to="/settings">{({ isActive }) => <span className={isActive ? "active" : ""}>設定</span>}</NavLink>
    </nav>
  );
}
